import React from "react";
import { Container, Typography, Box, Grid, Paper } from "@mui/material";

export default function About() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 10 }}>

        {/* Hero Section */}
        <Box sx={{ textAlign: "center", mb: 8 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 300,
              mb: 2,
              letterSpacing: "0.02em"
            }}
          >
            About Stakeholders
          </Typography>

          <Typography
            variant="h6"
            color="text.secondary"
            sx={{
              maxWidth: 700,
              margin: "0 auto",
              fontWeight: 300
            }}
          >
            A simple way to visualize and manage the people who shape your
            projects.
          </Typography>
        </Box>

        {/* Section */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" sx={{ fontWeight: 300, mb: 2 }}>
              See the Bigger Picture
            </Typography>
            <Typography color="text.secondary">
              Every project involves people — supporters, decision makers,
              advisors, and critics. Stakeholders helps teams map these
              relationships so it's easier to understand influence, priorities,
              and engagement across your entire project ecosystem.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="h4" sx={{ fontWeight: 300, mb: 2 }}>
              Designed for Clarity
            </Typography>
            <Typography color="text.secondary">
              Stakeholders keeps stakeholder management simple and visual.
              Instead of scattered notes or complex spreadsheets, you can see
              your entire stakeholder landscape in one clear view.
            </Typography>
          </Grid>
        </Grid>

        {/* Features */}
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                height: "100%"
              }}
            >
              <Typography variant="h6" sx={{ mb: 1 }}>
                Identify Influence
              </Typography>
              <Typography color="text.secondary">
                Understand who has the most impact on your project and where
                attention should be focused.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                height: "100%"
              }}
            >
              <Typography variant="h6" sx={{ mb: 1 }}>
                Track Engagement
              </Typography>
              <Typography color="text.secondary">
                Monitor stakeholder interest, urgency, and relationships so
                nothing falls through the cracks.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                height: "100%"
              }}
            >
              <Typography variant="h6" sx={{ mb: 1 }}>
                Align Your Team
              </Typography>
              <Typography color="text.secondary">
                Keep everyone on the same page with a shared understanding of
                stakeholder dynamics.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* Footer message */}
        <Box sx={{ textAlign: "center", mt: 10 }}>
          <Typography
            variant="h5"
            sx={{
              fontWeight: 300,
              mb: 1
            }}
          >
            Built for better decisions
          </Typography>

          <Typography color="text.secondary">
            Stakeholders helps teams understand the people behind their
            projects.
          </Typography>
        </Box>
      </Box>
    </Container>
  );
}